import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Layout from "./pages/Layout";

import Profile from "./pages/Profile";
import PendingDrivers from "./pages/PendingDrivers";
import OngoingBookings from "./pages/OngoingBookings";
import CompletedBookings from "./pages/CompletedBookings";
import CancelledBookings from "./pages/CancelledBookings";
//import PendingBookings from "./pages/PendingBookings";
import ExpiredBookings from "./pages/ExpiredBookings";
import BiddingBookings from "./pages/BiddingBookings";
import Users from "./pages/Users";
import DriverManagement from "./pages/Driver";
import WithdrawRequestsManagement from "./pages/WithdrawRequestsManagement";
import PricingManagement from "./pages/PricingManagement";
import SecuritySettings from "./pages/SecuritySettings";
import VersionConfig from "./pages/VersionConfig";
import ProtectedRoute from "./pages/ProtectedRoutes";
import BookingSearch from "./pages/BookingSearch";
import WalletLedger from "./pages/WalletLedger";
import AllWalletTransactions from "./pages/AllWalletTransactions";
import BroadcastNotification from "./pages/BroadcastNotification";
import PlatformSettings from "./pages/PlatformSettings";
import TicketsDashboard from "./pages/TicketsDashboard";
import PaymentReconciliation from "./pages/PaymentReconciliation";
import ServiceAreaManagement from "./pages/ServiceAreaManagement";
import AccountingDashboard from "./pages/AccountingDashboard";
import FinancialDocuments from "./pages/FinancialDocuments";
import AllDriversMap from "./pages/AllDriversMap";
import RadiusBookingMap from "./pages/RadiusBookingMap";

function App() {

  return (

    <BrowserRouter>

      <Routes>

        {/* PUBLIC ROUTE */}
        <Route path="/" element={<Login />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >

          <Route index element={<Dashboard />} />

          <Route
            path="profile"
            element={<Profile />}
          />

          <Route
            path="pending-drivers"
            element={<PendingDrivers />}
          />

          <Route
            path="ongoing-bookings"
            element={<OngoingBookings />}
          />

          <Route
            path="completed-bookings"
            element={<CompletedBookings />}
          />

          <Route
            path="cancelled-bookings"
            element={<CancelledBookings />}
          />

          <Route
            path="expired-bookings"
            element={<ExpiredBookings />}
          />

          {/*<Route
            path="pending-bookings"
            element={<PendingBookings />}
          />*/}

          <Route
            path="bidding-bookings"
            element={<BiddingBookings />}
          />

          <Route
            path="users"
            element={<Users />}
          />

          <Route
            path="driver"
            element={<DriverManagement />}
          />

<Route path="/dashboard/pricing" element={<PricingManagement />} />

          <Route
            path="security"
            element={<SecuritySettings />}
          />


          <Route
            path="widthrawrequest"
            element={<WithdrawRequestsManagement />}
          />

          <Route
            path="versionconfig"
            element={<VersionConfig />}
          />

          <Route
            path="bookingsearch"
            element={<BookingSearch />}
          />

           <Route
            path="broadcastnotification"
            element={<BroadcastNotification />}
          />

          <Route path="/dashboard/wallet/:driverId" element={<WalletLedger />} />

          <Route path="/dashboard/wallet-transactions" element={<AllWalletTransactions />} />

          <Route path="/dashboard/settings" element={<PlatformSettings />} />

          <Route path="/dashboard/ticket" element={<TicketsDashboard />} />

          <Route path="/dashboard/paymentreconciliation" element={<PaymentReconciliation />} />

          <Route path="/dashboard/service-area" element={<ServiceAreaManagement />} />

          <Route path="/dashboard/accounts" element={<AccountingDashboard />} />

          <Route path="/dashboard/financialdocs" element={<FinancialDocuments />} />

          <Route path="/dashboard/all-drivers" element={<AllDriversMap />} />

          <Route path="/dashboard/radius-booking" element={<RadiusBookingMap />} />

        </Route>

      </Routes>

    </BrowserRouter>

  );
}

export default App;